// Resolve API host for Vite (import.meta.env) and fallback to CRA env or window origin.
// In dev, force relative paths so Vite proxy can handle /api requests.
const IS_DEV = (typeof import.meta !== 'undefined' && import.meta.env?.DEV) === true;
const HOST = IS_DEV ? '' : (
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_HOST)
    || (typeof process !== 'undefined' && process.env?.REACT_APP_HOST)
    || (typeof window !== 'undefined' ? window.location.origin : '')
);

const API_ROUTES = {
    IS_LOGGED: HOST + '/api/house/isLogged',
    LOGIN: HOST + '/api/login',
    DEVICES_GET_DATA: HOST + '/api/house/devicesData',
    DEVICES_GET_PROGS: HOST + '/api/house/devicesProgs',
    DEVICES_CHANGE_STATE: HOST + '/api/house/changeState',
    DEVICES_METRICS: HOST + '/api/house/deviceMetrics',
    PROG_DISABLE_ENABLE: HOST + '/api/house/disableEnableProg',
    PROG_EDIT: HOST + '/api/house/editProg',
    PROG_SAVE: HOST + '/api/house/saveProg',
    PROG_CANCEL: HOST + '/api/house/cancelProg',
    VR_DATA: HOST + '/api/house/vrData',
    VR_OPERATION: HOST + '/api/house/vrOperation',
    ELEC_GET_CONSO: HOST + '/api/house/elecConso',
    ELEC_SEARCH_ADR: HOST + '/api/house/elecSearchAdresse',
    SAUTER_DEVICES_DATA: HOST + '/api/houseSauter/devicesData',
    SAUTER_CHANGE_STATE: HOST + '/api/houseSauter/changeState',
    SAUTER_DEVICES_PROGS: HOST + '/api/houseSauter/devicesProgs',
    SAUTER_PROG_SAVE: HOST + '/api/houseSauter/saveProg',
    SAUTER_PROG_EDIT: HOST + '/api/houseSauter/editProg',
    SAUTER_PROG_CANCEL: HOST + '/api/houseSauter/cancelProg',
    SAUTER_PROG_DISABLE_ENABLE: HOST + '/api/houseSauter/disableEnableProg',
    SAUTER_EJP_STATES: HOST + '/api/houseSauter/ejpStates',
    SAUTER_EJP_AUTO_STOP: HOST + '/api/houseSauter/ejpAutoStop',
    SAUTER_ELEC_CONSOS: HOST + '/api/houseSauter/consos',
    SAUTER_SERVICE_MAINTENANCE: HOST + '/api/houseSauter/serviceMaintenance',
};

export { API_ROUTES, HOST };
